import { actions } from "@/constants/state";
import store from "@/store";

export default async (to, from, next) => {
  try {
    await store.dispatch(actions.JOBS_FETCH_JOB_FILTERS_ACTION);
  } catch (error) {
    console.error(actions.JOBS_FETCH_JOB_FILTERS_ACTION, error);
  }

  next();
};
